module.exports = __webpack_public_path__ + "img/logo3.0a42f15c.png";